import axios from 'axios'
import store from '../store'
//import router from '../router'
import Vue from 'vue'

var errorShown = 0;

axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'
axios.defaults.data

// if(process.env.MIX_A_MODE == 'prod'){
//   axios.defaults.baseURL ="./public"
// }

axios.interceptors.request.use(request => {
    if (store.getters['Auth/CURRENT_USER']) {
     let {token}=store.getters['Auth/CURRENT_USER']
        request.headers.common['Authorization'] = `Bearer ${token}`
    }
    return request
})

axios.interceptors.response.use(response => response, error => {   
    if(error&&error.message == "Network Error" && errorShown<1){
        //console.log(error)
        Vue.$toast.error("please check your shop access key / network.");
        errorShown++;
        return
    }
    const { status, data } = error.response

    if (status >= 500) {
      console.log(error)
    }

  
   
    if (status === 401 && errorShown<1) {
       errorShown++;
        const vm = new Vue()
        
        vm.$toast.warning("Session expired.");
        console.log(data)
        store.dispatch('Auth/logout')

    }

    return Promise.reject(error)
})

export default axios
